import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTER_LINKS } from '../../consts/app-keys.const';
import { LogInIcon } from '../icons/log-in-icon.component';

export const HeaderButtons = () => {
  const { t } = useTranslation();
  return (
    <>
      <Link to={ROUTER_LINKS.SIGNIN}>
        <button
          type="button"
          className="flex justify-center font-body text-medium text-base-black whitespace-nowrap items-center h-[42px] min-w-[111px] px-[20px] py-[8px] gap-[6px]
    rounded-[32px] border border-border-alt bg-surface-secondary-alt
    shadow-[0px_2px_10px_0px_rgba(42,60,68,0.05)]
    transition-all duration-300
    hover:shadow-[0px_0px_0px_4px_rgba(93,225,255,0.20)] focus:shadow-[0px_0px_0px_4px_rgba(93,225,255,0.20)]"
        >
          {t('header.login')}
          <LogInIcon />
        </button>
      </Link>
      <Link to={ROUTER_LINKS.SIGNUP}>
        <button
          type="button"
          className="flex font-body text-medium whitespace-nowrap text-black h-[42px] min-w-[99px] px-[20px] py-[8px]
    justify-center items-center gap-[6px]
    border border-blue-600 bg-blue-500 rounded-[32px]
    transition-all duration-300
    hover:shadow-[0px_0px_0px_4px_rgba(93,225,255,0.20)] focus:shadow-[0px_0px_0px_4px_rgba(93,225,255,0.20)]"
        >
          {t('header.signup')}
        </button>
      </Link>
    </>
  );
};
